import { inject, provideEnvironmentInitializer } from '@angular/core';
import { provideSoftAppsModule, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_MDE_INVENTORY } from './inventory.permissions';
import { mdeInventoryRoutes } from './inventory.routes';
import { getModuleGroupById } from '@softline/application';
import {
  MdeInventoryModuleConfig,
  SOFTLINE_CONFIG_MDE_INVENTORY,
} from './inventory.shared';

export function provideMdeInventoryModule(config?: MdeInventoryModuleConfig) {
  return [
    {
      provide: SOFTLINE_CONFIG_MDE_INVENTORY,
      useValue: config ?? {
        showConfirmationOnFinalize: false,
      },
    },
    provideSoftAppsModule(
      {
        name: 'Inventur',
        title: 'Inventur',
        icon: 'fa-regular fa-shelves',
        route: '/mde-inventur',
        permission: SOFTLINE_PERMISSION_MDE_INVENTORY,
        group: getModuleGroupById(6),
      },
      withSoftAppsModuleRoutes({ app: mdeInventoryRoutes })
    ),
    provideEnvironmentInitializer(async () => {
      const store = inject(Store);
      store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: 'mdeInventur',
        language: 'de',
        translations: de,
      });
    }),
  ];
}
